<script setup>
import Header from '@features/shared/ui/Header.global.vue';
import Footer from '@features/shared/ui/Footer.global.vue';
</script>

<template>
  <div class="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950">
    <Header />
    <main class="flex-1">
      <router-view />
    </main>
    <Footer />
  </div>
  <component v-for="c in $autoMountComponents" :key="c" :is="c" />
  <VBusHelper :emitOnMounted="$constants.EVENTS.APP.READY" />
</template>
